import React, { useState, useEffect, useMemo } from 'react';
import { Grid, Typography, Box, IconButton } from "@material-ui/core";
import ButtonAtom from '../../component/ButtonAtom/index.jsx'
import { makeStyles } from '@material-ui/styles';
import Avatar from '@mui/material/Avatar';
import ProductItem from './../../component/ProductItem/index'
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import { useHistory, useLocation, useParams } from "react-router-dom";
import CallIcon from '@mui/icons-material/Call';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import GppGoodRoundedIcon from '@mui/icons-material/GppGoodRounded';
import firebase from "../../config/firebase/index";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { fontSize, fontWeight } from '@mui/system';
import Drawer from '@material-ui/core/Drawer';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import MobileBrowserMarketDrawer from './../../pages/Mobile_Browser_Market1/Mobile_Browser_Market1';
import ReactGA from "react-ga";
import encSecret from '../../config/encryption/index.js';
import VisibilitySensor from 'react-visibility-sensor';
import { Button } from '@mui/material';
import Suggest_Bid from '../../pages/Suggest_Bid/Suggest_Bid.js';
import SuggestTable from '../SuggestTable/index.jsx';
import DialogItemAtom from '../DialogItemAtom/index.jsx';
import MessageAtom from '../MessagAtom/index.jsx';
var CryptoJS = require("crypto-js");
var viewDeals = [];


const PublicDeals = (props) => {
    const deals = [...props.deals];

    const classes = useStyles();
    // const [deals, setDeals] = useState(props.deals);
    const user = JSON.parse(localStorage.getItem("user"));
    const [dealId, setDealId] = useState("");
    const [deal, setDeal] = useState("");
    const [load, setLoad] = useState(false);
    const [open, setOpen] = useState(false);
    const [open1, setOpen1] = useState(false);
    const [methodFlag, setMethodFlag] = useState("call");
    const [link, setLink] = useState("");
    const [DealerPhoneNo, setDealerPhoneNo] = useState("");
    const [selectedDeal, setSelectedDeal] = useState("");
    const [more, setMore] = useState(true);
    const [quantityUnit, setQuantityUnit] = useState("");
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    const [date, setDate] = useState(new Date());
    const [openDialog, setOpenDialog] = useState(false);


    function SimpleDialog(props) {
        const { onClose, selectedValue, open } = props;

        const handleClose = () => {
            onClose(false);
        };

        return (
            <Dialog onClose={handleClose} open={open}>
                <DialogTitle>Disclaimer</DialogTitle>
                <Box ml={2} mr={2} mb={2}>
                    <Typography style={{ textAlign: "justify", wordSpacing: "-2px" }}>
                        The platform provides information for reference purposes and users are advised to exercise their discretion to check and verify the information provided on the platform independently. The company specifically states that it is not liable to any of its users financially or legally for any activity causing harm or financial/ commercial loss due to reliance placed on the information provided on the platform.

                    </Typography>
                </Box>
            </Dialog>
        );
    }


    const NoOfViews = async (deal) => {
        console.log("Views");
        console.log("viewDeals", viewDeals);
        if (!viewDeals.includes(deal.id)) {
            viewDeals.push(deal.id)
            console.log("viewDeals After ", viewDeals);
            firebase.database().ref(`Product/${deal.id}/analytics/views`).set(parseInt(deal.analytics.views) + 1);

        }
    }

    const NoOfCalls = async (deal) => {
        firebase.database().ref(`Product/${deal.id}/analytics/phone`).set(parseInt(deal.analytics.phone) + 1);
        createCustomer("call", deal.id);

    }

    const NoOfWhatsapp = async (deal) => {
        firebase.database().ref(`Product/${deal.id}/analytics/whatsapp`).set(parseInt(deal.analytics.whatsapp) + 1)
        createCustomer("whatsapp", deal.id);
    }

    console.log(props.deals);




    const formatDate = (DATE) => {
        let d = DATE.split(" ");
        let dd = d[0].split("-");
        let newDATE = dd[1] + "/" + dd[2] + "/" + dd[0] + " " + d[1];
        // console.log("NDATE ::: ", newDATE);
        let nDate = new Date(newDATE);

        // console.log("::: :", nDate);
        let dateArr = nDate.toString().split(" ");
        let hrs = nDate.getHours();
        let mnts = nDate.getMinutes();
        let AMPM = hrs >= 12 ? 'PM' : 'AM';
        hrs = hrs % 12;
        hrs = hrs ? hrs : 12;
        mnts = mnts < 10 ? '0' + mnts : mnts;
        var result = dateArr[2] + " " + dateArr[1] + ", " + hrs + ':' + mnts + ' ' + AMPM;
        return result;
        // return nDate.toLocaleString('en-IN', { day: 'numeric', month: 'short', hour: 'numeric', minute: 'numeric', hour12: true })
    }

    const formatMonthDate = (num) => {
        return parseInt(num) > 9 ? num : "0" + num;
    }

    const createdAt = () => {
        const today = new Date();
        const date = today.getFullYear() + '-' + formatMonthDate(today.getMonth() + 1) + '-' + formatMonthDate(today.getDate());
        const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

        const dateTime = date + ' ' + time;

        return dateTime;
    }

    const handleClose = () => {
        setOpen1(false);

    };

    const dealGA = (category, action, label) => {
        console.log("GA event:", category, ":", action, ":", label);
        ReactGA.event({
            category: category,
            action: action,
            label: label,
        })
    }

    const createCustomer = async (method, dealId) => {
        const customerRef = firebase.database().ref('Customer');
        const customer = {
            DealId: dealId,
            Name: user[0].Name,
            PhoneNo: user[0].PhoneNo,
            img: user[0].img,
            method: method,
            time: createdAt()
        };

        customerRef.push(customer);
    };

    const toggleDrawer = (method, deal) => {
        setOpen(!open);
        setDealId(deal.id);
        setDeal(deal);
        console.log(method, deal);
        setQuantityUnit(deal.QuantityUnit);
        setDealerPhoneNo(deal.DealerNumber);
        if (method === "call") {
            const phoneLink = "tel:" + deal.DealerNumber;
            setLink(phoneLink);
            setMethodFlag(method);
        } else {
            const whatsAppLink = "https://wa.me/91" + deal.DealerNumber;
            setLink(whatsAppLink);
            setMethodFlag(method);
        }

    };


    // console.log("Public Deals ::: ", deals);


    return (
        // <div style={{ display: "block", height: "75vh", overflow: "scroll" }}>
        <div>
            {deals && deals.map((deal, index) => (
                <VisibilitySensor
                    onChange={(isVisible) => {
                        // console.log("DEAL :::::", deal)
                        if (isVisible) {
                            NoOfViews(deal);
                        }
                    }}

                >
                    <>
                        <Box key={index} className={classes.kishanDetail}>
                            <Box className={classes.textCenterSet}>
                                <Box mr={1}>
                                    <Avatar alt="Remy Sharp" src={deal.DealerImage} />
                                </Box>
                                <Typography variant="body1" style={{ fontWeight: 600 }}>
                                    {CryptoJS.AES.decrypt(deal.DealerName, encSecret.key).toString(CryptoJS.enc.Utf8)}<br />{formatDate(deal.createdAt)}
                                </Typography>
                            </Box>
                            <Box className={classes.textCenterSet}>
                                {/* <Box ml={1} className={classes.rotateSHareIcon}>
                                    <GppGoodRoundedIcon />
                                </Box> */}
                                {isLoggedIn ?
                                    <a href={"https://wa.me/91" + deal.DealerNumber} style={{ textDecoration: 'none' }}>
                                        <Typography variant="body1" >
                                            <WhatsAppIcon onClick={() => { NoOfWhatsapp(deal); deal('Deal', 'Click', 'WhatsApp') }} style={{ background: "green", color: "white", borderRadius: 50, fontSize: "230%" }} />
                                        </Typography>
                                    </a>
                                    :
                                    <Typography variant="body1" >
                                        <WhatsAppIcon onClick={() => { toggleDrawer("whatsapp", deal); deal('Deal', 'Click', 'WhatsApp') }} style={{ background: "green", color: "white", borderRadius: 50, fontSize: "230%" }} />
                                    </Typography>
                                }

                            </Box>
                        </Box>
                        <ProductItem image={deal.image} productName={deal.productName} minPrice={CryptoJS.AES.decrypt(deal.Min, encSecret.key).toString(CryptoJS.enc.Utf8)} maxPrice={CryptoJS.AES.decrypt(deal.Max, encSecret.key).toString(CryptoJS.enc.Utf8)} place={deal.Place} quantity={deal.Quantity} quantityUnit={deal.QuantityUnit} isPublic={deal.isPublic} />

                        {/* {isLoggedIn ?
                            <Box className={classes.contetnArrange}>
                                <Box mr={1} fullwidth>
                                    <a href={"tel:" + deal.DealerNumber} style={{ textDecoration: 'none' }}>
                                        <ButtonAtom
                                            startIcon={<CallIcon />}
                                            name="कॉल करे "
                                            onClick={() => { isLoggedIn ? NoOfCalls(deal) : toggleDrawer("call", deal); dealGA('Deal', 'Click', 'Phone call'); }}

                                        /></a>
                                </Box>
                                <Box ml={1} fullwidth>
                                    <Button
                                        variant={"outlined"}
                                        onClick={() => { toggleDrawer("suggest", deal) }}
                                        style={{ border: "1px solid #53252f", color: "#53252f", padding: "6px 15px", fontSize: "120%", width: "100%" }}
                                    >
                                        बोली दर्ज करें
                                    </Button>
                                </Box>
                            </Box> :
                            <Box className={classes.contetnArrange}>
                                <Box mr={1} fullwidth>
                                    <ButtonAtom
                                        startIcon={<CallIcon />}
                                        name="कॉल करे "
                                        onClick={() => { toggleDrawer("call", deal); dealGA('Deal', 'Click', 'Phone call'); }}

                                    />
                                </Box>
                                <Box ml={1} fullwidth>
                                    <Button
                                        variant={"outlined"}
                                        onClick={() => { toggleDrawer("suggest", deal) }}
                                        style={{ border: "1px solid #53252f", color: "#53252f", padding: "6px 15px", fontSize: "120%", width: "100%" }}
                                    >
                                        बोली दर्ज करें
                                    </Button>
                                </Box>
                            </Box>
                        } */}
                        <Box style={{ padding: "0px 30% 5px 30%", textAlign: "center", marginTop: "10px" }}>

                            <Button
                                // name="बोली दर्ज करें"
                                onClick={() => {
                                    // toggleDrawer("suggest", deal) 
                                    setOpen1(true);
                                    setDate(new Date());
                                    console.log(deal);
                                    setSelectedDeal(deal);
                                }}
                                style={{
                                    borderRadius: "5px",
                                    boxShadow: "0 3px 6px 0 rgba(255, 255, 255, 0.58)",
                                    border: "solid 1px #53252f",
                                    backgroundColor: "#53252f",
                                    color: "white",
                                    padding: "5px 20px",
                                    fontSize: 16
                                }}
                            // >बोली दर्ज करें</Button>
                            >बेहतर भाव
                            </Button>


                        </Box>
                        <Box style={{ padding: "5px 20px" }}>
                            <MessageAtom message={deal.Message} len={46} />
                            <Box mt={1}>
                                {<SuggestTable id={deal.id} />}
                            </Box>
                            <Box mb={2}>
                                <Typography variant="body1" style={{ fontSize: 12 }} onClick={() => { setOpenDialog(true) }}>
                                    {/* * सभी भाव आज रात 12 बजे तक है */}
                                    * Click here to read the platform advisory.
                                </Typography>
                            </Box>
                        </Box>
                    </>
                </VisibilitySensor>

            )).reverse()
            }
            <div>
                {/* <Drawer className={classes.drawerDesign} anchor={'bottom'} open={open}>
                    <MobileBrowserMarketDrawer PhoneNo={DealerPhoneNo} closePopUp={setOpen} link={link} methodFlag={methodFlag} dealId={dealId} />
                </Drawer> */}
                {methodFlag == "suggest" ?
                    <div >
                        <Drawer className={classes.drawerDesign} anchor={'bottom'} open={open}>
                            <Suggest_Bid PhoneNo={DealerPhoneNo} closePopUp={setOpen} link={link} methodFlag={methodFlag} dealId={dealId} selectedDeal={deal.id} date={new Date()} quantityUnit={quantityUnit} loggedIn={isLoggedIn ? true : false} />
                        </Drawer>
                    </div>
                    :
                    <div >
                        <Drawer className={classes.drawerDesign} anchor={'bottom'} open={open}>
                            <MobileBrowserMarketDrawer PhoneNo={DealerPhoneNo} closePopUp={setOpen} link={link} methodFlag={methodFlag} dealId={dealId} quantityUnit={quantityUnit} loggedIn={isLoggedIn ? true : false} />
                        </Drawer>
                    </div>
                }
                <DialogItemAtom
                    open={open1}
                    onClose={handleClose}
                    PhoneNo={selectedDeal.DealerNumber} closePopUp={setOpen} link={link} methodFlag={"suggest"} dealId={selectedDeal.id} quantityUnit={selectedDeal.QuantityUnit} loggedIn={isLoggedIn ? true : false}
                    selectedDeal={selectedDeal.id} date={new Date()}
                />
            </div>
            <SimpleDialog
                open={openDialog}
                onClose={() => setOpenDialog(!openDialog)}
            />
        </div >
    );
}

const useStyles = makeStyles(() => ({
    drawerDesign: {
        '& .MuiDrawer-paper': {
            paddingTop: 20,
            borderRadius: '20px 20px 0 0',
        }
    },
    headerBrowser: {
        background: '#53252f',
        color: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
    },
    kishanDetail: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
    },
    textCenterSet: {
        display: 'flex',
        alignItems: 'center',
    },
    rotateSHareIcon: {
        transform: 'rotateY(360deg)',
    },
    contetnArrange: {
        width: '100%',
        padding: '10px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        '& div': {
            width: '100%'
        }
    },
    commonSectionBuild: {
        maxWidth: 540,
        float: 'none',
        margin: '0 auto'
    },
    manageIconCenter: {
        justifyContent: 'center',
        padding: '50px 0 20px',
        boxSizing: 'border-box',
    },
    image: {
        width: '35px',
        height: '35px',
        borderRadius: '50%',
        position: 'relative',
        overflow: 'hidden',
    },
    footerFixed: {
        position: 'fixed',
    },

    dealerCall: {
        width: '55%',
        padding: '10px 20px',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: '200px',
        marginLeft: '60px',
    },
}))

export default PublicDeals;
